module.exports = __webpack_public_path__ + "assets/img/honor-bg.da608b62.png";